<template>
  <div
    :class="[
      'payment-method-list-warning',
      !showCTAWarning && 'payment-method-list-warning--with-top-border',
    ]"
  >
    <div class="payment-method-list-warning__wrapper">
      <AlertCircleIcon class="payment-method-list-warning__text-icon" />
      <p class="payment-method-list-warning__text">
        Replacing your payment method will also update your reoccuring subscription payment method.
      </p>
      <p v-show="showCTAWarning" class="payment-method-list-warning__cta">
        Are you sure you want to continue?
      </p>
    </div>
  </div>
</template>

<script>
import AlertCircleIcon from '@/assets/icons/alert_circle.svg'

export default {
  name: 'PaymentMethodListWarning',
  props: {
    showCTAWarning: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  components: {
    AlertCircleIcon: { ...AlertCircleIcon, name: 'AlertCircleIcon' },
  },
}
</script>

<style lang="scss">
.payment-method-list-warning {
  align-items: center;
  justify-content: center;
  bottom: 1px;
  font-size: rem(14);
  @include font-book;
  color: var(--white);
  margin: 5px 0;
  @include tablet {
    margin: 0;
  }
  &--with-top-border {
    border-top: 1px solid var(--gray-3);
    padding-top: 30px;
  }
  &__wrapper {
    display: grid;
    grid-template-columns: 10% 90%;
  }
  &__text {
    margin-top: 0;
    margin-bottom: 0;
    &-icon {
      grid-area: 1/1/3/2;
      margin: auto;
    }
  }
  &__cta {
    margin: 0;
  }
}
</style>
